// utils/score.js
export const calculateInspectionScore = (formData) => {
  console.log("Calculating score for form data:", formData);

  const isYes = (val) => {
    if (val === true) return true;
    if (val === false) return false;
    if (typeof val === "string") {
      const v = val.trim().toLowerCase();
      if (v === "yes" || v === "true") return true;
      if (v === "no" || v === "false") return false;
    }
    return false; // default
  };

  let rawScore = 0;

  // 1️⃣ Use of plastic → Yes = 0 (bad), No = 10 (good)
  rawScore += isYes(formData.useOfPlastic) ? 0 : 10;

  // 2️⃣ Biodegradable materials → Yes = 10, No = 0
  rawScore += isYes(formData.biodegradableMaterialsUsed) ? 10 : 0;

  // 3️⃣ Dustbins → Yes = 10, No = 0
  rawScore += isYes(formData.dustbinsAvailable) ? 10 : 0;

  // 4️⃣ Waste disposed properly → Yes = 10, No = 0
  rawScore += isYes(formData.wasteDisposedProperly) ? 10 : 0;

  // 5️⃣ Cleanliness rating → numeric 0–10 (clamp)
  const cleanlinessScore = Math.min(
    10,
    Math.max(0, Number(formData.cleanlinessRating) || 0)
  );
  rawScore += cleanlinessScore;

  // 6️⃣ Waste/food on ground → Yes = 0 (bad), No = 10 (good)
  rawScore += isYes(formData.wasteOnGround) ? 0 : 10;

  // Normalize rawScore (0–60) to a 0–100 scale and round
  const finalScore = Math.round((rawScore / 60) * 100);

  // For debugging:
  console.log("Raw score:", rawScore, "/60 → Final (0-100):", finalScore);

  return finalScore;
};
